import React from "react"

import { styled } from "@mui/material/styles"
import { Slider } from "@mui/material"

import { getVolume, setVolume } from "../utils/userUtils"

const VolumeContainer = styled('div')`
  position: relative;
  display: flex;
  justify-content: center;
`

const VolumeSliderContainer = styled('div')`
  position: absolute;
  background-color: black;
  height: 96px;
  width: 30px;
  display: flex;
  flex-direction: column;
  border-radius: 10px;
  align-items: center;
  top: 42px;
`

const VolumeIcon = styled('i')`
  &.fas {
    width: 30px; // NOTE: To avoid navbar collapsing issues when swapping from low to high volume
    height: 32px !important;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    font-size: 18px;
    margin: 0 5px;
  }
`

const SFSlider = styled(Slider)`
  height: 80px;
`

export default class VolumeControl extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      volumeSliderVisible: false,
    }
  }

  handleVolumeSliderChange = (event, value) => {
    // setState to trigger re-render
    this.setState({ volumeValue: value })
    setVolume(value)
  }

  handleVolumeIconMouseEnter = () => {
    this.setState({ volumeSliderVisible: true })
  }

  handleVolumeIconMouseLeave = () => {
    this.setState({ volumeSliderVisible: false })
  }

  renderVolumeIcon(volumeValue) {
    let fontAwesomeClassName

    if (volumeValue >= 60) {
      fontAwesomeClassName = "fas fa-volume-up"
    } else if (volumeValue > 0 && volumeValue < 60) {
      fontAwesomeClassName = "fas fa-volume-down"
    } else {
      fontAwesomeClassName = "fas fa-solid fa-volume-xmark"
    }

    return (
      <VolumeIcon
        className={fontAwesomeClassName}
        aria-label={`Volume control - ${volumeValue}%`}
        tabIndex="0"
      ></VolumeIcon>
    )
  }

  render() {
    const { volumeSliderVisible } = this.state
    const volumeValue = getVolume()

    return (
      <VolumeContainer
        onMouseEnter={this.handleVolumeIconMouseEnter}
        onMouseLeave={this.handleVolumeIconMouseLeave}
      >
        {this.renderVolumeIcon(volumeValue)}
        {volumeSliderVisible && (
          <VolumeSliderContainer>
            <SFSlider
              aria-label="Volume"
              orientation="vertical"
              value={volumeValue}
              size="small"
              onChange={this.handleVolumeSliderChange}
              max={100}
              min={0}
              aria-valuemin="0"
              aria-valuemax="100"
              aria-valuenow={volumeValue}
            />
          </VolumeSliderContainer>
        )}
      </VolumeContainer>
    )
  }
}
